module.exports = __webpack_public_path__ + "static/img/banner.e9162f65.jpg";